import styles from './HolePill.module.css';

export default function HolePill({ hole }) {
  return (
    <span className={hole === 1 ? styles.holePillH1 : styles.holePillH10}>
      Hole {hole}
    </span>
  );
}
